<template>
  <input-form-box>
    <section>
      <div class="tags-royalties-wrap">
        <app-input-tag
          v-model="tagValue"
          type="text"
          name="Tags"
          labelText="Tags"
          labelClass="label"
          inputTagClass="form-box-input"
          tagInputWrap="tag-input-wrap"
          class="tags-royalties"
        />
        <app-input
          type="number"
          labelText="Royalties"
          labelClass="label"
          @keydown="filterKey"
          @input="onInput"
          v-model="localRoyalties"
          name="Royalties"
          placeholder="Add a percentage"
          :suggestions="true"
          :percents="[
            { value: 10, text: '10%' },
            { value: 20, text: '20%' },
            { value: 30, text: '30%' },
          ]"
          inputClass="form-box-input"
          class="tags-royalties"
        />
      </div>
      <div class="voice-over-wrap">
        <app-input
          type="text"
          labelText="Alternative Text"
          labelClass="label"
          v-model="localAlternativeText"
          name="Alternative Text"
          inputClass="form-box-input"
          componentClass="section-inputs"
        />
        <div class="voice-over-text">
          Text that will be used in VoiceOver for people with disabilities
        </div>
      </div>
    </section>
    <div class="form-box-buttons-controls">
      <app-button
        text="Back"
        @click.prevent="decrementStep()"
        buttonClass="app-modal-button"
      />
      <app-button
        text="Preview"
        type="submit"
        form="mint-nft"
        buttonClass="app-modal-button-inverse"
        @click="commitToStore()"
      />
    </div>
  </input-form-box>
</template>
<script>
import AppInputTag from "@/elements/AppInputTag";
import AppInput from "@/elements/AppInput.vue";
import AppButton from "@/elements/AppButton.vue";
import InputFormBox from "@/elements/InputFormBox.vue";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import useMinting from "../../composables/useMinting";
export default {
  name: "MintDetails",
  components: {
    AppInput,
    AppButton,
    AppInputTag,
    InputFormBox,
  },
  setup() {
    const store = useStore();
    const tagValue = ref("");
    const localRoyalties = ref(null);
    const localAlternativeText = ref("");
    const lastValidInputValue = ref("");

    const { royalties, alternativeText, decrementStep, updateBulk } =
      useMinting(store);

    if (alternativeText.value)
      localAlternativeText.value = alternativeText.value;

    if (royalties.value) localRoyalties.value = royalties.value;

    const tags = computed(() => store.getters["tagsValues/getByKey"]("tags"));

    const commitToStore = () =>
      updateBulk({
        tags: tags.value,
        royalties: localRoyalties.value,
        alternativeText: localAlternativeText.value,
      });
    const filterKey = (e) => {
      const key = e.key;
      if (key === "e") return e.preventDefault();
      if (key === "-" || key === "+") return e.preventDefault();
    };

    const onInput = (e) => {
      if (navigator.userAgent.indexOf("Firefox") != -1) {
        if (e.target.value !== "") {
          lastValidInputValue.value = e.target.value;
        } else if (e.inputType.match(/delete/g)) {
          lastValidInputValue.value = "";
        } else {
          e.target.value = lastValidInputValue.value;
        }
      }
      if (e.target.value !== "") {
        localRoyalties.value = parseFloat(e.target.value);
      }
    };

    return {
      tags,
      tagValue,
      filterKey,
      onInput,
      lastValidInputValue,
      localRoyalties,
      decrementStep,
      commitToStore,
      localAlternativeText,
    };
  },
};
</script>
